const TIPOS_PAQUETES_CONTRATACION = [
  {
    id: 1,
    name: 'Paquete profesional',
  },
  {
    id: 2,
    name: 'Paquete jurídico',
  },
  {
    id: 3,
    name: 'Paquete despacho',
  },
]

export {
  TIPOS_PAQUETES_CONTRATACION
}
